import {
  AccountBalanceWalletOutlined,
  EditNotificationsOutlined,
  InfoOutlined,
  KeyOutlined,
  LogoutOutlined,
  ManageAccountsOutlined,
  SupportOutlined
} from '@mui/icons-material';
import { authentication } from '../../../../../../authentication';
import { USER_GUIDE_PATH } from '../../../../../../../api/constans';
import { USER_OPTIONS } from './interfaces';

import { IsMobileState } from '../../../../../../hooks/useMobile';
import { CheckIfUserHasPortalPrivilege, PORTAL_PRIVILEGE } from '../../../../../../common/client-status/interfaces';
import { IconType } from '../../../../../../common/icon';

const divider = { isDivider: true };

interface Props {
  isMobile: IsMobileState;
  setOptionSelected: (arg: USER_OPTIONS) => void;
  handleOpenDialog: () => void;
  checkIfUserHasPortalPrivilege: CheckIfUserHasPortalPrivilege;
}

type UserAction = {
  label: string;
  icon: IconType;
  portalPrivilege: PORTAL_PRIVILEGE;
  userOption: USER_OPTIONS;
};

const supportedUserActions: UserAction[] = [
  {
    label: 'Add funds to your wallet',
    icon: AccountBalanceWalletOutlined,
    portalPrivilege: 'WALLET_CREDIT',
    userOption: USER_OPTIONS.ADD_FUNDS_TO_YOUR_WALLET
  },
  {
    label: 'Account information',
    icon: ManageAccountsOutlined,
    portalPrivilege: 'CLIENT_INFO',
    userOption: USER_OPTIONS.ACCOUNT_INFORMATION
  },
  {
    label: 'Client secrets regeneration',
    icon: KeyOutlined,
    portalPrivilege: 'REGENERATE_SECRETS',
    userOption: USER_OPTIONS.CLIENT_SECRETS_REGENERATION
  },
  {
    label: 'Low balance notification',
    icon: EditNotificationsOutlined,
    portalPrivilege: 'LOW_BALANCE_NOTIFICATION_SETTINGS',
    userOption: USER_OPTIONS.LOW_BALANCE_NOTIFICATION
  }
];

export const getUserActions = ({
  isMobile,
  setOptionSelected,
  handleOpenDialog,
  checkIfUserHasPortalPrivilege
}: Props) => {
  const accountActions = supportedUserActions
    .filter(userAction => checkIfUserHasPortalPrivilege(userAction.portalPrivilege))
    .map(userAction => ({
      label: userAction.label,
      icon: userAction.icon,
      onClick: () => {
        setOptionSelected(userAction.userOption);
        handleOpenDialog();
      }
    }));

  const pageActions = [
    {
      label: 'About',
      icon: InfoOutlined,
      onClick: () => {
        setOptionSelected(USER_OPTIONS.ABOUT);
        handleOpenDialog();
      }
    },
    {
      label: 'Docs and Support',
      icon: SupportOutlined,
      onClick: () => {
        window.open(`${window.location.origin}${USER_GUIDE_PATH}`, '_blank');
      }
    }
  ];

  const logoutAction = {
    label: 'Logout',
    icon: LogoutOutlined,
    onClick: () => {
      authentication.logout();
    }
  };

  if (isMobile === 'initialized') return [];

  return accountActions.length !== 0
    ? [...accountActions, divider, ...pageActions, divider, logoutAction]
    : [...accountActions, ...pageActions, divider, logoutAction];
};
